<h1>General Error</h1>
<ul>
    <li *ngFor="let error of errors">
        <pre>{{error | errorMessage}}</pre>
    </li>
</ul>
